var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66797 5.50033C1.66797 5.04009 2.04106 4.66699 2.5013 4.66699H17.5013C17.9615 4.66699 18.3346 5.04009 18.3346 5.50033C18.3346 5.96056 17.9615 6.33366 17.5013 6.33366H2.5013C2.04106 6.33366 1.66797 5.96056 1.66797 5.50033Z",
    fill: "#918F93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33203 2.99967C8.11102 2.99967 7.89906 3.08747 7.74278 3.24375C7.5865 3.40003 7.4987 3.61199 7.4987 3.83301V4.66634H12.4987V3.83301C12.4987 3.61199 12.4109 3.40003 12.2546 3.24375C12.0983 3.08747 11.8864 2.99967 11.6654 2.99967H8.33203ZM14.1654 4.66634V3.83301C14.1654 3.16997 13.902 2.53408 13.4331 2.06524C12.9643 1.5964 12.3284 1.33301 11.6654 1.33301H8.33203C7.66899 1.33301 7.03311 1.5964 6.56426 2.06524C6.09542 2.53408 5.83203 3.16997 5.83203 3.83301V4.66634H4.16536C3.70513 4.66634 3.33203 5.03944 3.33203 5.49967V17.1663C3.33203 17.8294 3.59542 18.4653 4.06426 18.9341C4.5331 19.4029 5.16899 19.6663 5.83203 19.6663H14.1654C14.8284 19.6663 15.4643 19.4029 15.9331 18.9341C16.402 18.4653 16.6654 17.8294 16.6654 17.1663V5.49967C16.6654 5.03944 16.2923 4.66634 15.832 4.66634H14.1654ZM4.9987 6.33301V17.1663C4.9987 17.3874 5.0865 17.5993 5.24278 17.7556C5.39906 17.9119 5.61102 17.9997 5.83203 17.9997H14.1654C14.3864 17.9997 14.5983 17.9119 14.7546 17.7556C14.9109 17.5993 14.9987 17.3874 14.9987 17.1663V6.33301H4.9987Z",
    fill: "#918F93"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33333 8.83301C8.79357 8.83301 9.16667 9.2061 9.16667 9.66634V14.6663C9.16667 15.1266 8.79357 15.4997 8.33333 15.4997C7.8731 15.4997 7.5 15.1266 7.5 14.6663V9.66634C7.5 9.2061 7.8731 8.83301 8.33333 8.83301Z",
    fill: "#918F93"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6654 8.83301C12.1256 8.83301 12.4987 9.2061 12.4987 9.66634V14.6663C12.4987 15.1266 12.1256 15.4997 11.6654 15.4997C11.2051 15.4997 10.832 15.1266 10.832 14.6663V9.66634C10.832 9.2061 11.2051 8.83301 11.6654 8.83301Z",
    fill: "#918F93"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon-trash.183ae145d019b8a27de53f7199ce00df.svg";
export { ForwardRef as ReactComponent };